import React, { useContext, useState, useEffect } from 'react';

import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { CloseRounded } from '@mui/icons-material';
import { Button, CircularProgress } from '@mui/material';

const UploadAgentLogo = ({ modalDetails }) => {
  
  const data = modalDetails.data;
  console.log(data);
  
  const [avatar, setAvatar] = useState(data.avatar);
  const agentID = data.id;

  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);

  const [isUploading, setIsUploading] = useState(false);

  const closeHandle = () => {
    modalCtx.closeModal();
  }

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const response = await updateAvatar(file);
        console.log('Image uploaded successfully:', response);
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  async function updateAvatar(file) {
    try {
      const formData = new FormData();
      formData.append("file", file);

      setIsUploading(true);
  
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/agent/${agentID}/uploadlogo`, {
        method: 'POST',
        headers: { Authorization: "Bearer " + authCtx.token},
        body: formData,
      });
  
      if (!response.ok) {
        throw new Error('Failed to update Avatar');
      } else {
        const result = await response.json();
        setAvatar(result.imagePath);
        setIsUploading(false);
        modalCtx.setPageUpdate({ page: "Agents", agentId: agentID });
      }
    } catch (error) {
      console.error('Error updating Avatar', error);
      throw error;
    }
  }

  const generateTempAvatar = (name) => {
    let initials = "";
    
    if (!name || name.trim().toUpperCase() === "N/A") {
      initials = "N/A";
    } else {
      initials = name.split(" ").map((word) => word.charAt(0).toUpperCase()).slice(0, 2).join("");
    }
  
    return (
      <div
        style={{
          height: "100px",
          width: "100px",
          borderRadius: "100%",
          backgroundColor: "#576574",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          fontSize: "45px",
          fontWeight: "bold",
          marginBottom: "40px",
        }}
      >
        {initials}
      </div>
    );
  };  

  return (
    <div className="modal-container">
      <div className='modal-header'>
        <h1>{avatar ? "Update Avatar" : "Add Avatar"}</h1>
      </div>
      <div className="modal-body">
        <div className='upload-logo-body'>
          <p className='heading'>Agent Avatar</p>
          {isUploading ? ( <CircularProgress size={32} style={{ color: "#1c2238" }} />) : (avatar ? ( <img style={{ height: '100px', width: '100px', borderRadius: '100%', marginBottom:"40px"}} src={avatar}></img>) : (generateTempAvatar(`${data.firstName} ${data.lastName}` || "N/A")))}
        </div>
        <div>
          <p style={{fontSize:"13px"}}>(NOTE: This will be used as a circle avatar in all instances. Please upload a square image 512x512)</p>
          <input type="file" id="fileInput" style={{ display: "none" }} onChange={handleFileUpload} />
          <button onClick={() => document.getElementById("fileInput").click()}>Choose File</button>
        </div>
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={() => closeHandle()}>Close</Button>
      </div>
    </div>
  )
}

export default UploadAgentLogo;
